import { render, staticRenderFns } from "./FooterIndex.vue?vue&type=template&id=1af05474&scoped=true"
var script = {}
import style0 from "./FooterIndex.vue?vue&type=style&index=0&id=1af05474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af05474",
  null
  
)

export default component.exports